export default ngInject(function($uibModalInstance, supplierDeliverableFoodhubs, foodhub) {
  this.supplierDeliverableFoodhubs = supplierDeliverableFoodhubs;

  this.selectedFoodhubSlug = foodhub.slug;

  this.submit = (params) => {
    $uibModalInstance.close(params);
  };

  this.cancel = () => $uibModalInstance.dismiss();

  return this;
});
